export const calcScore = (voltage: number, price: number, volume: number) => (voltage * volume) / (price * 100)
